import api from "../services/api"
import { toast } from "react-toastify"

const getTeams = async () => {
    try {
        const response = await api.get(`/teams/onlyCrm`)
        const teams = response.data?.data
        return teams
    } catch (err) {
        toast.error(err?.response?.data?.message)
    }
}

export { getTeams }